import config from 'config';
import noop from 'lodash/noop';

import { isTouchOnly } from 'atg/utils/device';
import * as Utils from 'atg/utils/Utils';
import {
  PLACE_BET_CANCEL,
  PLACE_BET_DOWNLOAD_FILE,
  PLACE_BET_RIKSTOTO,
} from 'shared/constants/TrackingConstants';
import { trackUser } from 'shared/redux/actions';
import { getStore } from 'shared/redux/store';
import { formatDateCompact } from 'shared/utils/dateUtils';
import { formatMoney } from 'shared/utils/money';
import { getText } from 'shared/utils/Text';

import Dialog from './Dialog';

const $ = window.$;

export default class NorwayExportDialog extends Dialog {
  constructor(delegate, responseData, onClose = noop) {
    super('dialog-export-norway', null, delegate);

    this.onClose = onClose;
    this.onButtonPressed = this.onButtonPressed.bind(this);
    this.$container.find('a.active').event('click', this.onButtonPressed);
    this.$container.find('button').event('click', this.onButtonPressed);
    this._init(responseData);
    this.dispatch = getStore().dispatch;
  }

  _dispatchTrackEvent(eventName) {
    const api = this.getAPI();
    const betKey = api.betInformation.getBetKey();

    new Promise((resolve, reject) => {
      api.loadBetKeyInfo(betKey, betKeyInfo => {
        if (betKeyInfo) {
          resolve(betKeyInfo);
        } else {
          reject();
        }
      });
    }).then(
      betKeyInfo => {
        const gameType = betKey.getBetType();
        const price = api.getStake().getStake();
        const formattedPrice = formatMoney(price.getSum(), price.getCurrency());
        const track = betKeyInfo.getTrack().getName();
        const date = betKeyInfo.getTime();

        getStore().dispatch(
          trackUser(eventName, {
            gameType,
            closeTime: date.toISOString(),
            stake: formattedPrice,
            round: `${gameType}-${track}-${formatDateCompact(date)}`,
          }),
        );
      },
      () => {
        // Skip tracking on failure
      },
    );
  }

  _init(responseData) {
    const { draftReference, missingHorses, userMessage } = responseData;

    this.rikstotoDraftIdParam = draftReference;

    Utils.insertTexts(this.$container);

    const $text = this.$container.find('.text');
    const $warnings = this.$container.find('.warnings');
    const $apiLabel = this.$container.find('#api .label');

    const $downloadButton = this.$container.find('#download');
    const $downloadLabel = $downloadButton.find('.label');
    const $downloadMobileWarning = $downloadButton.find('.mobile-warning');

    const $downloadUsbButton = this.$container.find('#download-usb');
    const $downloadUsbLabel = $downloadUsbButton.find('.label');
    const $downloadUsbMobileWarning =
      $downloadUsbButton.find('.mobile-warning');

    const $negativeLabel = this.$container.find('#cancel .label');

    // Add warnings if any

    const warnings = [];

    if (missingHorses) {
      const { missingHorsesLegs } = missingHorses;
      const legNumbers = Object.keys(missingHorsesLegs);

      if (legNumbers.length > 0) {
        let html = getText('dialog-export-warning-horses-without-marks');
        html += '<br/>';

        for (const [key, value] of Object.entries(missingHorsesLegs)) {
          html += getText(
            'dialog-export-warning-horses-without-marks-leg',
            key,
            value.join(', '),
          );
          html += '<br/>';
        }
        warnings.push(`<p>${html}</p>`);
      }
    }

    if (userMessage) {
      warnings.push(`<p>${userMessage}</p>`);
    }

    if (warnings.length > 0) {
      $warnings.html(warnings.join('<hr/>'));
    } else {
      this.$container.find('.has-warnings').remove();
    }

    $negativeLabel.text(getText('dialog-export-button-cancel'));

    $text.html(getText('dialog-export-text'));
    $apiLabel.text(getText('dialog-export-button-play-api'));
    $downloadLabel.text(getText('dialog-export-button-play-coop'));
    $downloadUsbLabel.text(getText('dialog-export-button-play-usb'));
    if (isTouchOnly()) {
      $downloadButton.addClass('disabled');
      $downloadMobileWarning.text(getText('dialog-export-requires-desktop'));
      $downloadUsbButton.addClass('disabled');
      $downloadUsbMobileWarning.text(getText('dialog-export-requires-desktop'));
    }
  }

  onButtonPressed(event) {
    const eventValue = $(event.currentTarget).data('value');
    if (eventValue === 'rikstoto') {
      window.open(
        `https://rikstoto.no/System?draftid=${this.rikstotoDraftIdParam}&agentId=${config.rikstotoAgentId}`,
        '_blank',
      );
      this._dispatchTrackEvent(PLACE_BET_RIKSTOTO);
    } else if (eventValue === 2 || eventValue === 3) {
      this._dispatchTrackEvent(PLACE_BET_DOWNLOAD_FILE);
    } else {
      this._dispatchTrackEvent(PLACE_BET_CANCEL);
    }
    this.onClose(eventValue);
    this.close();
  }

  willCloseFromOutside() {
    this._dispatchTrackEvent(PLACE_BET_CANCEL);
    this.onClose(false);
  }
}
